// Campos reutilizáveis das telas de conta.
import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

export function Field({ label, opcional, error, hint, children, htmlFor }) {
    return (
        <div className="pfield">
            {label && (
                <label className="plabel" htmlFor={htmlFor}>
                    {label} {opcional && <span className="popt">(opcional)</span>}
                </label>
            )}
            {children}
            {error ? <span className="perr">{error}</span> : hint ? <span className="phint">{hint}</span> : null}
        </div>
    );
}

export function TextField({ label, opcional, error, hint, ...props }) {
    return (
        <Field label={label} opcional={opcional} error={error} hint={hint} htmlFor={props.id}>
            <input className={`pinput ${error ? 'pinput--error' : ''}`} {...props} />
        </Field>
    );
}

export function PasswordField({ label = 'Senha', error, hint, ...props }) {
    const [show, setShow] = useState(false);
    return (
        <Field label={label} error={error} hint={hint} htmlFor={props.id}>
            <div className="pinput-wrap">
                <input
                    className={`pinput ${error ? 'pinput--error' : ''}`}
                    type={show ? 'text' : 'password'}
                    {...props}
                />
                <button
                    type="button"
                    className="pinput-eye"
                    onClick={() => setShow((s) => !s)}
                    aria-label={show ? 'Ocultar senha' : 'Mostrar senha'}
                    tabIndex={-1}
                >
                    {show ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
            </div>
        </Field>
    );
}
